import Vue from 'vue'
import config from './config'

// Vue Fontawesome 
require('./fontawesome.js')

// Buefy
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
Vue.use(Buefy, {
    defaultIconPack: 'fas',
    defaultIconComponent: 'font-awesome-icon',
    defaultLocale: ['es-MX', 'en-US']
})

// Axios
import axios from 'axios'
axios.defaults.baseURL = config.publicUrl
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios = axios

// Set Global Vars
Vue.prototype.$publicUrl = config.publicUrl
Vue.prototype.$appName = config.appName
Vue.prototype.$token = config.token
Vue.prototype.$whatsApp = config.whatsApp
Vue.config.productionTip = false
Vue.config.ignoredElements = [/^ion-/]

Vue.component('carruselportafolio', require('./components/carruselportafolio.vue').default);
Vue.component('contactoform', require('./components/contactoform.vue').default);
Vue.component('blogcategorias', require('./components/blogcategorias.vue').default);
Vue.component('blogtrending', require('./components/blogtrending.vue').default);
Vue.component('blogsocialshare', require('./components/blogsocialshare.vue').default);
Vue.component('blogsocialshareblog', require('./components/blogsocialshareblog.vue').default);
Vue.component('footersocialshare', require('./components/footersocialshare.vue').default);
Vue.component('whatsappfloatbutton', require('./components/whatsappfloatbutton.vue').default);

// Vue Config
Vue.config.productionTip = false

// Share Window Dialog
import { shareDialog, shareOnPage } from './share_tools'

new Vue({
    mounted() {
        this.delayAndFadeOut()
        this.initNavigationEffect()
        this.setHamburgerBtn()
        this.smoothAnchorScroll()
    },
    el: '#app',
    methods: {
        delayAndFadeOut() {
            setTimeout(() => {
                let fadeTarget = document.getElementsByClassName('preloader')[0]
                const fadeEffect = setInterval(() => {
                    if (!fadeTarget.style.opacity) {
                        fadeTarget.style.opacity = 1
                    }
                    if (fadeTarget.style.opacity > 0) {
                        fadeTarget.style.opacity -= 0.1
                    } else {
                        fadeTarget.style.display = 'none'
                        clearInterval(fadeEffect)
                    }
                }, 50)
            }, 1000)
        },
        initNavigationEffect() {
            let navbar = document.getElementsByTagName('nav')[0]
            window.addEventListener('scroll', function () {
                const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
                if (currentScrollPosition > 0) {
                    navbar.classList.add("nav-effect")
                } else {
                    navbar.classList.remove("nav-effect")
                }
            })
        },
        setHamburgerBtn() {
            let btnHamburger = document.getElementsByClassName('btn-hamburger')[0]
            let btnCloseHamburger = document.getElementsByClassName('btn-close-hamburger')[0]
            let menu = document.getElementById('menu')

            btnHamburger.addEventListener('click', () => {
                menu.classList.toggle('menu-effect')
                this.toggleHamburgerClasses(menu.childNodes[2].childNodes)
                
            })

            btnCloseHamburger.addEventListener('click', () => {
                menu.classList.toggle('menu-effect')
                this.toggleHamburgerClasses(menu.childNodes[2].childNodes)
            })
        },
        toggleHamburgerClasses(elements) {
            elements.forEach(element => {
                if (element.tagName === 'LI') {
                    element.classList.toggle('li-effect')
                }
            })
        },
        smoothAnchorScroll() {
            document.querySelectorAll('a[href^="#"]').forEach(anchor => {
                anchor.addEventListener('click', function (e) {
                    e.preventDefault()
            
                    document.querySelector(this.getAttribute('href')).scrollIntoView({
                        behavior: 'smooth'
                    })
                })
            })
        }
    }
})
